<div class="container">
  <div class="top-bar">
    <div class="title">SIGN UP</div>
    <div class="close">
      <cs-icon-button iconType="icon" icon="fi-x" size="12" color="secondary" (buttonClick)="close()"> </cs-icon-button>
    </div>
  </div>
  <div class="content">
    <div class="text">Please confirm the following to create your account in Pubs.com.</div>

    <div class="check">
      <input type="checkbox" name="check-old" id="check-old" [(ngModel)]="checkedOld" />
      <label for="check-old">I am at least 18 years old</label>
    </div>

    <div class="check">
      <input type="checkbox" name="check-terms" id="check-terms" [(ngModel)]="checkedTerms" />
      <div class="check-text">
        <label for="check-terms">I accept the</label>
        <span class="link" (click)="jumpToAgree($event)"> terms and conditions </span>
        <span>and the</span>
        <span class="link" (click)="jumpToPolicy($event)"> privacy policy. </span>
      </div>
    </div>

    <cs-button
      class="submit"
      size="large"
      label="Continue"
      [disabled]="!checkedOld || !checkedTerms"
      (buttonClick)="submit()"
    ></cs-button>
  </div>
</div>
